import Component from '../../shared/component';

export default class GroupMessageFormToggle extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.$form = this.$element.find('.groupMessageForm');
    this.$teaser = this.$element.find('.groupWindow-formTeaser');
    this.$toggler = this.$element.find(
      '.toggleForm-trigger, .groupMessageForm-button--cancel'
    );

    this.bindEvents();
  }

  bindEvents() {
    this.handleToggle = this.handleToggle.bind(this);

    this.$toggler.on('click.GroupMessageFormToggle', this.handleToggle);
  }

  unbindEvents() {
    this.$toggler.off('click.GroupMessageFormToggle', this.handleToggle);
  }

  handleToggle() {
    this.$teaser.toggleClass('hidden');
    this.$form.toggleClass('hidden');
  }
}
